// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookmark-body {
    padding: 0.5em;
    display: flex;
    flex-direction: column;
    /* titlebar: 2.5em */
    max-height: calc(100vh - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/
    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/
}

div.bookmark-create > input {
    width: 100%;
}

div.bookmark-actions {
    margin: 0.5em 0;
}

span.bookmark-actions-spacer {
    flex: 1 1 auto;
}

span.bookmark-actions > button:not(:disabled) > span.icon-trash {
    color: red;
}

div.bookmark-list {
    border: 1px solid var(--border-color);
    background-color: var(--list-bg-color);
    flex: 1 1 auto;
    overflow-y: auto;
}

div.bookmark-list-item {
    padding: 0.5em;
    overflow: hidden;
    overflow-wrap: anywhere;
}

div.bookmark-list-item-empty {
    padding: 0.5em;
    font-style: italic;
    color: var(--text-color-disabled);
}

div.bookmark-list-item:not(.bookmark-list-item-active):nth-child(even) {
    background-color: var(--list-item-bg-color-even);
}

div.bookmark-list-item:hover {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

div.bookmark-list-item-active {
    background-color: var(--list-item-bg-color-active);
    color: var(--list-item-text-color-active);
}

div.bookmark-list-item-active:hover {
    background-color: var(--list-item-bg-color-active-hover);
    color: var(--list-item-text-color-active-hover);
}
`, "",{"version":3,"sources":["webpack://./plugins/style/Bookmark.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gFAAgF,EAAE,oDAAoD;IACtI,+FAA+F,EAAE,oDAAoD;AACzJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,wDAAwD;IACxD,+CAA+C;AACnD","sourcesContent":[".bookmark-body {\n    padding: 0.5em;\n    display: flex;\n    flex-direction: column;\n    /* titlebar: 2.5em */\n    max-height: calc(100vh - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/\n    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/\n}\n\ndiv.bookmark-create > input {\n    width: 100%;\n}\n\ndiv.bookmark-actions {\n    margin: 0.5em 0;\n}\n\nspan.bookmark-actions-spacer {\n    flex: 1 1 auto;\n}\n\nspan.bookmark-actions > button:not(:disabled) > span.icon-trash {\n    color: red;\n}\n\ndiv.bookmark-list {\n    border: 1px solid var(--border-color);\n    background-color: var(--list-bg-color);\n    flex: 1 1 auto;\n    overflow-y: auto;\n}\n\ndiv.bookmark-list-item {\n    padding: 0.5em;\n    overflow: hidden;\n    overflow-wrap: anywhere;\n}\n\ndiv.bookmark-list-item-empty {\n    padding: 0.5em;\n    font-style: italic;\n    color: var(--text-color-disabled);\n}\n\ndiv.bookmark-list-item:not(.bookmark-list-item-active):nth-child(even) {\n    background-color: var(--list-item-bg-color-even);\n}\n\ndiv.bookmark-list-item:hover {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\ndiv.bookmark-list-item-active {\n    background-color: var(--list-item-bg-color-active);\n    color: var(--list-item-text-color-active);\n}\n\ndiv.bookmark-list-item-active:hover {\n    background-color: var(--list-item-bg-color-active-hover);\n    color: var(--list-item-text-color-active-hover);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
